import { combineReducers } from 'redux';
import { forms, constants as circeConstants, reducer as circeReducer } from 'circe';
import appReducer from 'appReducer';
import { REDUCER_NAME as APP_REDUCER_NAME } from 'constants';

import singleReducer from 'domain/fuse/single/reducer';
import { REDUCER_NAME as SINGLE_REDUCER_NAME } from 'domain/fuse/single/constants';

import submitReducer from 'domain/fuse/submit/reducer';
import { REDUCER_NAME as SUBMIT_REDUCER_NAME } from 'domain/fuse/submit/constants';

const rootReducer = combineReducers({
  [circeConstants.REDUCER_NAME]: circeReducer,
  form: forms.provider.formReducer,
  [APP_REDUCER_NAME]: appReducer,

  [SINGLE_REDUCER_NAME]: singleReducer,
  [SUBMIT_REDUCER_NAME]: submitReducer,
});

export default rootReducer;
